import { Component, EventEmitter, Output } from '@angular/core';
import { ExtModalComponent } from '../ext-modal/ext-modal.component';

@Component({
  selector: 'app-maintenance-modal',
  standalone: true,
  imports: [ExtModalComponent],
  template: `
    <app-ext-modal
      [type]="'error'"
      [visible]="visible"
      [title]="'Servicio en Mantenimiento'"
      [paragraph]="
        'Nuestros servicios se encuentran en mantenimiento. Por favor, contacte a su administrador.'
      "
      [confirmText]="'Entendido'"
      (onClose)="onClose.emit()"
    />
  `,
})
/**
 * Componente modal para mostrar mensaje de mantenimiento
 */
export class MaintenanceModalComponent {
  /** Indica si el modal está visible */
  visible = true;

  /** Evento emitido al cerrar el modal */
  @Output() onClose = new EventEmitter<void>();
}
